import { Box, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Card, InterfaceLabel, Label } from '@tiendanube/components';

interface CustomerPriceTablesSkeletonProps {
  headerLabel?: InterfaceLabel | 'skeleton';
}

export default function CustomerPriceTablesSkeleton({
  headerLabel,
}: Readonly<CustomerPriceTablesSkeletonProps>) {
  const { t } = useTranslation(Domain.CUSTOMERS);
  const tPath = 'customerDetails.customerPriceTables';

  return (
    <Card title={t(`${tPath}.title`)} headerLabel={headerLabel}>
      <div style={{ marginLeft: '-1rem', marginRight: '-1rem' }}>
        <DataList>
          <DataList.Row id="skeleton">
            <Box marginBottom="0-5">
              <Text.Skeleton width="100px" />
            </Box>
            <Text.Skeleton width="130px" />
            <Box display="flex" gap="2" marginTop="0-5">
              <Label.Skeleton />
            </Box>
          </DataList.Row>
        </DataList>
      </div>
    </Card>
  );
}
